// extracted by mini-css-extract-plugin
export default {"select":"SelectTags_select__WlHJT"};